import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import classnames from 'classnames';
import "react-alice-carousel/lib/alice-carousel.css";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Wrapper from './style';


class Carousel extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			currentIndex: 0,
			isPrevSlideDisabled: true,
			isNextSlideDisabled: false,
		};
	}

	componentDidMount() {
		const { isActive } = this.props;
		this.setState({ currentIndex: 0 }, isActive ? this.slidePrev : null);
	}

	// onInitialized = ({
	// 	item: currentIndex,
	// 	isPrevSlideDisabled,
	// 	isNextSlideDisabled,
	// }) =>
	// 	this.setState({ currentIndex, isPrevSlideDisabled, isNextSlideDisabled });

	onSlideChanged = ({
		item: currentIndex,
		isPrevSlideDisabled,
		isNextSlideDisabled,
	}) =>
		this.setState({ currentIndex, isPrevSlideDisabled, isNextSlideDisabled });

	slidePrev = () => {
		const { isPrevSlideDisabled } = this.state;
		if (!isPrevSlideDisabled) {
			this.setState((prevState) => ({
				currentIndex: prevState.currentIndex - 1,
			}));
		}
	};

	slideNext = () => {
		const { isNextSlideDisabled } = this.state;

		if (!isNextSlideDisabled) {
			this.setState((prevState) => ({
				currentIndex: prevState.currentIndex + 1,
			}));
		}
	};

	render() {
		const { items, containerClass, isInfinite, responsive } = this.props;
		const {
			currentIndex,
			// isPrevSlideDisabled,
			// isNextSlideDisabled,
		} = this.state;
		const { onSlideChanged, slidePrev, slideNext } = this;

		return (
			<Wrapper>
				<div
					className={classnames('carousel__container', {
						containerClass: !!containerClass,
					})}
				>
					<div
						className='slider-button'
						onClick={slidePrev}
					>
						<LeftOutlined />
					</div>
					<div className="carousel__alice-wrapper">
						<AliceCarousel
							infinite={isInfinite}
							disableDotsControls={true}
							disableButtonsControls={true}
							items={items}
							responsive={responsive}
							activeIndex={currentIndex}
							onSlideChanged={onSlideChanged}
						// onInitialized={onInitialized}
						/>
					</div>
					<div
						className='slider-button'
						onClick={slideNext}
					>
						<RightOutlined />
					</div>
				</div>
			</Wrapper>
		);
	}
}

export default Carousel;
